module.exports = __webpack_public_path__ + "img/logo.308d15b6.svg";